export default __webpack_public_path__ + "static/media/agentAccounting.45b33c2e.svg";